import {BusinessDriverT} from "../../../model/Customer";

export class Service {
    serviceId: number;
    name: string;
    description?: string;
    businessDrivers: BusinessDriverT[];
    batchSize?: number;
}
